<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <b-dropdown id="dropdown-dropright" :text="`${perPage} itens por página`" variant="outline-dark" dropright size="sm" class="m-2">
                  <b-dropdown-item @click="limitPage(20)">20 itens por página</b-dropdown-item>
                  <b-dropdown-item @click="limitPage(50)">50 itens por página</b-dropdown-item>
                  <b-dropdown-item @click="limitPage(100)">100 itens por página</b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newVideo()">
                      <i class="mdi mdi-plus mr-1"></i> Novo Vídeo
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th style="width: 20px;"></th>
                    <th style="width: 90px;">Thumb</th>
                    <th>Título</th>
                    <th style="width: 90px;">Provedor</th>
                    <th style="width: 150px;">Status</th>
                    <th style="width: 90px;">Ações</th>
                  </tr>
                </thead>
                <draggable
                  v-model="videos"
                  :element="'tbody'"
                  :options="{animation:200, handle:'.mover'}"
                  @change="updateSequence"
                >
                  <tr v-for="list in videos" :key="list.id">
                    <td class="mover">
                      <span class="badge font-size-13 badge-soft-primary p-1 badge-num">{{ list.sequence }}</span>
                    </td>
                    <td class="mover">
                      <div v-if="list.thumbnail_url">
                        <img class="rounded" :src="list.thumbnail_url" alt :style="{ width: '72px', height: '40px', objectFit: 'cover' }" />
                      </div>
                    </td>
                    <td class="mover">
                      <h5 class="font-size-14 mb-1">
                        <span class="text-dark">{{ list.title || '(Sem título)' }}</span>
                      </h5>
                      <p class="text-muted mb-0 small">{{ list.url }}</p>
                    </td>
                    <td class="mover">
                      <span class="badge badge-pill font-size-12" :class="{
                        'badge-soft-danger': list.provider === 'youtube',
                        'badge-soft-info': list.provider === 'vimeo'
                      }">{{ providerLabel[list.provider] || list.provider }}</span>
                    </td>
                    <td class="mover">
                      <span class="badge badge-pill font-size-12" :class="{
                        'badge-soft-success': `${parseInt(list.status)}` === '1',
                        'badge-soft-danger': `${parseInt(list.status)}` === '0'
                      }">{{ statusLabel[list.status] }}</span>
                    </td>
                    <td>
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item @click="editVideo(list.id)">
                          <i class="fas fa-pencil-alt text-success mr-1"></i> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="toggleStatus(list.id)">
                          <i class="fas fa-circle mr-1" :class="{ 'text-danger': parseInt(list.status) === 1, 'text-success': parseInt(list.status) === 0 }"></i> {{ list.status ? 'Inativar' : 'Ativar' }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="removeVideo(list.id)">
                          <i class="fas fa-trash-alt text-danger mr-1"></i> Excluir
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import draggable from 'vuedraggable'
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    draggable,
    Layout,
    PageHeader
  },
  name: 'Videos',
  page: {
    title: 'Vídeos',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  data () {
    return {
      loading: true,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      statusLabel: ['Inativo', 'Ativo'],
      providerLabel: { youtube: 'YouTube', vimeo: 'Vimeo' },
      submitted: false,
      title: 'Vídeos',
      items: [
        { text: 'Vídeos' },
        { text: 'Listagem', active: true }
      ]
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  computed: {
    ...mapGetters('videos', { data: 'VIDEOS' }),
    ...mapState('videos', ['pagination']),
    rows () {
      return this.pagination.total
    },
    videos: {
      get () {
        return this.data
      },
      set (value) {
        let loader = this.$loading.show()
        this.updateSequence({ itens: value }).then(() => {
          loader.hide()
          successMessage('Sucesso: Ordem atualizada.', 2500)
        })
      }
    }
  },
  methods: {
    ...mapActions('videos', {
      GetVideos: 'GetVideos',
      changeStatus: 'changeStatus',
      removeAction: 'deleteVideo',
      updateSequence: 'orderList'
    }),
    newVideo () {
      this.$router.push({ name: 'site-video-new' })
    },
    editVideo (id) {
      this.$router.push({ name: 'site-video-edit', params: { id: id } })
    },
    async toggleStatus (id) {
      try {
        await this.changeStatus(id)
        successMessage('Sucesso: Status atualizado com sucesso.', 2500)
        this.updateList()
      } catch (err) {
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    removeVideo (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.removeAction(id)
            successMessage('Sucesso: Vídeo excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    updateList () {
      let loader = this.$loading.show()
      this.GetVideos({ limit: this.perPage, page: this.currentPage }).then(() => {
        loader.hide()
      })
    },
    limitPage (limit) {
      this.perPage = limit
      this.updateList()
    }
  }
}
</script>
<style>
.link { cursor: pointer; }
.swal2-popup { font-size: 11px !important; }
.table-responsive { min-height: 300px; }
.float-sm-end { float: right }
</style>
